import React, { useState } from 'react';
import { Snackbar, Slide, Box, IconButton, Typography } from '@mui/material';
import grey from '@mui/material/colors/grey';
import { ExportCodeBlockMenuButton } from './ExportCodeBlockMenuButton';
import { ToolbarIconButton } from '../ui/ToolbarIconButton/ToolbarIconButton';
import { ClipboardIcon } from '../ui/ClipboardIcon/ClipboardIcon';
import { CodeBlock } from '../../types/RealtaDocument';
import { ToolbarToggleButton } from '../ui/ToolbarToggleButton/ToolbarToggleButton';
import WrapTextIcon from '@mui/icons-material/WrapText';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import useRole from '../../utils/use-role';
import SaveIcon from '@mui/icons-material/Save';

function SlideTransition(props: any) {
  return <Slide {...props} direction="up" />;
}

const CodeBlockToolbar = ({
  codeBlock,
  hightLight,
  setHightLight,
  lineWrapping,
  setLineWrapping,
  generateCodeBlock,
  saveCodeBlock,
}: {
  codeBlock: CodeBlock;
  hightLight: boolean;
  setHightLight: Function;
  lineWrapping: boolean;
  setLineWrapping: Function;
  generateCodeBlock: () => void;
  saveCodeBlock: () => void;
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const { isReadOnly } = useRole();

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleCopy = () => {
    const el = document.createElement('textarea');
    el.value = codeBlock.rule;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setOpenSnackbar(true);
  };

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message="Rules copied to clipboard!"
        TransitionComponent={SlideTransition}
      />
      <Box
        sx={{
          backgroundColor: grey[200],
          p: 1,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          {!!codeBlock.createdBy && (
            <Typography variant="body2" fontSize={12}>
              Created by: {codeBlock.createdBy}
            </Typography>
          )}
          {!!codeBlock.updatedBy && (
            <Typography variant="body2" fontSize={12}>
              Updated by: {codeBlock.updatedBy}
            </Typography>
          )}
        </Box>
        <Box>
          <IconButton
            onClick={saveCodeBlock}
            title="Save Code Block"
            sx={{
              margin: '0',
              border: 'none',
              marginLeft: '3px !important',
              color: '#000 !important',
              height: '30px',
              padding: '0px 4px',
            }}
            disabled={isReadOnly}
          >
            <SaveIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={generateCodeBlock}
            title="Re-generate Code Block"
            sx={{
              margin: '0 3px',
              border: 'none',
              marginLeft: '3px !important',
              color: '#000 !important',
              height: '30px',
              padding: '0px 4px',
            }}
            disabled={isReadOnly}
          >
            <ChangeCircleOutlinedIcon fontSize="small" />
          </IconButton>
          <ToolbarToggleButton
            value="syntax"
            selected={hightLight}
            onChange={() => setHightLight(!hightLight)}
            title={hightLight ? 'Syntax highlight off' : 'Syntax highlight on'}
          >
            <FormatColorTextIcon fontSize="small" />
          </ToolbarToggleButton>
          <ToolbarToggleButton
            value="wrap"
            selected={lineWrapping}
            onChange={() => setLineWrapping(!lineWrapping)}
            title={lineWrapping ? 'Word wrap off' : 'Word wrap on'}
          >
            <WrapTextIcon fontSize="small" />
          </ToolbarToggleButton>
          <ToolbarIconButton
            aria-label="copy rules to clipboard"
            onClick={handleCopy}
            disabled={!codeBlock.rule}
            title="Copy to clipboard"
          >
            <ClipboardIcon />
          </ToolbarIconButton>
          <ExportCodeBlockMenuButton rule={codeBlock.rule} />
        </Box>
      </Box>
    </>
  );
};

export default CodeBlockToolbar;
